import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCookie } from 'libraries/cookie'

export const categoriesApi = createApi({
  reducerPath: 'categoriesApiV2',
  baseQuery: fetchBaseQuery({
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || '';
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId);
      }
      const token = getCookie('token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
    baseUrl: window.config.API_URL,
  }),
  endpoints: builder => ({
    fetchCategoriesList: builder.query<any, any>({
      query: ({ customer_id, parent_id, is_supplier }) => {
        if (is_supplier) {
          // POST запрос для поставщика
          // Защита от вызова с null/undefined customer_id
          if (!customer_id || customer_id === 'null' || customer_id === 'undefined') {
            throw new Error('customer_id is required for supplier categories')
          }

          const body: any = {
            filter_has_products: true,
            filter_customer_id: customer_id,
          }

          // Добавляем filter_parent_id только если он передан и не null/undefined
          if (parent_id !== null && parent_id !== undefined) {
            body.filter_parent_id = parent_id
          }

          return {
            url: '/suppliers/v3/categories',
            method: 'POST',
            body,
          }
        } else {
          // POST запрос для обычного клиента
          return {
            url: '/v2/categories',
            method: 'POST',
            body: {
              filter_parent_id: parent_id,
              filter_with_products: true,
            },
          }
        }
      },
    }),
  }),
})

export const { useFetchCategoriesListQuery } = categoriesApi
